// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"3019":"697039efe22ccc8d3a24","3713":"7fe5c119bda561d690ea","4588":"ef0848d68cd61c101839"}[chunkId] + ".js";
};